import PropTypes from 'prop-types';
import React from 'react';

type SearchResultListLoadingShimmerProps = {
  rows: number
};

const RowShimmerEtab: React.FC = () => {
  return <>
    <div className="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-animate-pulse tw-border-t">
      <div className="tw-col-span-12 sm:tw-col-span-4 lg:tw-col-span-3">
        <div className="tw-bg-gray-200 tw-border tw-border-gray-300" style={{ height: "225px" }} />
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-8 lg:tw-col-span-9">
        <div className="tw-h-full tw-p-2 tw-flex tw-flex-col tw-justify-between">
          <div>
            <div className="tw-flex tw-justify-between">
              <div className="tw-font-semibold tw-mb-3 tw-w-full">
                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-mb-2 tw-w-1/2"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-w-1/3"></div>
              </div>
            </div>
            <div className="tw-w-4/5 tw-mt-5">
              <div className="tw-mb-2">
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1 tw-w-1/2"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
              </div>
            </div>
          </div>
          <div className="tw-mt-1">
            <div className="tw-flex tw-justify-end tw-items-center tw-w-full tw-gap-x-2">
              <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-w-1/5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}

const RowShimmerProposal: React.FC = () => {
  return <>
    <div className="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-animate-pulse tw-border-t tw-border-b">
      <div className="tw-col-span-12 sm:tw-col-span-4 lg:tw-col-span-3">
        <div className="tw-bg-gray-200 tw-border tw-border-gray-300" style={{ height: "225px" }} />
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-8 lg:tw-col-span-9">
        <div className="tw-h-full tw-p-2 tw-flex tw-flex-col tw-justify-between">
          <div>
            <div className="tw-flex tw-justify-between">
              <div className="tw-font-semibold tw-mb-3 tw-w-full">
                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-mb-2 tw-w-1/2"></div>
                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-1/3"></div>
              </div>
            </div>
            <div className="tw-w-4/5 tw-mt-5">
              <div className="tw-mb-2">
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1 tw-w-1/2"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
                <div className="tw-h-2 tw-bg-gray-200 tw-rounded tw-mb-1"></div>
              </div>
            </div>
          </div>
          <div className="tw-mt-1">
            <div className="tw-flex tw-justify-end tw-items-center tw-w-full tw-gap-x-2">
              <div className="tw-h-10 tw-bg-primary-100 tw-rounded w-1/6"></div>
              <div className="tw-h-10 tw-bg-primary-100 tw-rounded w-1/6"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>;
}

const SearchResultListLoadingShimmer: React.FC<SearchResultListLoadingShimmerProps> = ({ rows }) => {
  return (
    <>
      <RowShimmerEtab />
      {
        Array.from(Array(rows)).map((n, i) => {
          return <RowShimmerProposal key={`rshimmer_${n}_${i}`} />
        })
      }
    </>
  )
};

SearchResultListLoadingShimmer.propTypes = {
  rows: PropTypes.number.isRequired
};

export default SearchResultListLoadingShimmer;
